import * as React from 'react'

function SvgHomeDesktopHeaderBG(props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="100%" height="100%" viewBox="0 0 1441 323" fill="none" {...props}>
      <path
        d="M725.973 166.549C345.925 187.954.736 322.21.736 322.21V.244H1440.74v194.138c-121.09-19.152-334.72-49.238-714.767-27.833z"
        fill="url(#prefix__paint0_radial)"
      />
      <defs>
        <radialGradient
          id="prefix__paint0_radial"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(-84.67604 -492.01375 1935.07191 -333.02775 910.632 257.424)"
        >
          <stop stopColor="#03CDFE" />
          <stop offset={0.523} stopColor="#317CE9" />
          <stop offset={0.958} stopColor="#E9315D" />
        </radialGradient>
      </defs>
    </svg>
  )
}

export default SvgHomeDesktopHeaderBG
